<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<support />
		<div
			class=" p-3 float-left"
			:class="(chechRole()) ? 'h-center col-lg-9 col-md-9 col-sm-12 col-xs-12 ' : 'col-lg-9 col-md-9 col-sm-12 col-xs-12 ' "
		>
			<back
				:title="(this.$route.params.id == undefined) ? 'مدرس جدید' : 'ویرایش مدرس _ '+t_name"
				showBtn="true"
				v-if="!chechRole()"
			/>
			<getPhone 
				@next_page='next_page'
				v-if="val.page == 0"
			/>
			<check_phone
				:value="val" 
				@next_page='next_page'
				v-if="val.page == 1"
			/>
			<identity 
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 2 && chechRole()"
			/>
			<identity_edit 
				:val="val" 	
				@next_page='next_page'
				v-if="val.page == 2 && !chechRole()"
			/>
			<personalInformation 
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 3 && chechRole()"
			/> 
			<personalInformation_edit 
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 3 && !chechRole()"
			/> 
			<further_information
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 4"
			/>
			<teaching_information
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 5"
			/>
			<educational_information
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 6"
			/>
			<about_me
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 7"
			/>
			<wait_signup
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 8 && chechRole()"
			/>
			<set_status
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 8 && !chechRole()"
			/>
			<approval
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 9"
			/>
			<defects
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 10"
			/>
			<teacher_failed
				:val="val" 
				@next_page='next_page'
				v-if="val.page == 11"
			/>
		</div>
		<leftMenuUser
			class="col-lg-3 col-md-3 float-left"
			select="1"
			v-if="!chechRole()"
		/>
		<leftMenuPublic
			class="col-lg-3 col-md-3 float-left"
			select="1"
			v-else
		/>
		<footerPage />
	</div>
</template>

	<script>
		import getPhone from  "./getPhone.vue";
		import about_me from  "./about_me.vue";
		import wait_signup from  "./wait_signup.vue";
		import approval from  "./approval.vue";
		import defects from  "./defects.vue";
		import teacher_failed from  "./teacher_failed.vue";
		import set_status from  "./set_status.vue";
		import further_information from  "./further_information.vue";
		import educational_information from  "./educational_information.vue";
		import teaching_information from  "./teaching_information.vue";
		import check_phone from  "./check_phone.vue";
		import headMenu from  "../../menu/headMenu.vue";
		import back from  "../../UI/back/back.vue";
		import support from  "../../UI/support/support.vue";
		import footerPage from  "../../USER/public/home/home_part9.vue";
		import leftMenuUser from  "../../menu/leftMenuUser.vue";
		import leftMenuPublic from  "../../menu/leftMenuPublic.vue";

		import identity from  "./identity.vue";
		import identity_edit from  "./identity_edit.vue";
		import personalInformation from  "./personalInformation.vue";
		import personalInformation_edit from  "./personalInformation_edit.vue";

		export default {
			name: 'signupTeacher',
			data(){
				return {
					val: {
						page: 0,
					},
					t_name: "",
					t_status:[
						'ثبت نام بدون احراز هویت',
						'فعال',
						'پروفایل کامل/ غیرفعال/ ادمین',
						'بلاک شده‌ها',
						'4',
						'حذف شدها',
						'درخواست تغییر یا ارتقا',
						'پروفایل ناقص با احراز هویت',
						'8',
						'9',
						'پروفایل کامل/غیرفعال/در انتظار بررسی مدارک',
						'نقص مدارک ارزیابی',
						'رد شدها',
						'در انتظار فعال سازی',
					]
				}
			},
			components: {
				getPhone,
				set_status,
				wait_signup,
				defects,
				approval,
				teacher_failed,
				about_me,
				check_phone,
				teaching_information,
				further_information,
				educational_information,
				back,
				footerPage,
				headMenu,
				leftMenuPublic,
				leftMenuUser,
				identity,
				identity_edit,
				personalInformation,
				personalInformation_edit,
				support,
			},
			props: [],
			computed :{
			},
			mounted(){
				this.$swal.close();
				this.loader();
				if(this.$localStorage.get('user') != undefined){
					if(this.$localStorage.get('user').username.role == 2){
						this.$localStorage.set("s_id_t", this.$localStorage.get('user').username.id);
					}
				}
				let user = this.$localStorage.get('user');
				if(user != null){
					if(user.username.role==2 && user.username.status!=0){
						this.val.value = user.username;
						this.val.page = 4;
					}
					if(user.username.role==2 && user.username.status==0){
						this.val.value = user.username;
						this.val.page = 2;
					}
				}
			},
			methods:{
				// *********************************************************************
				loader(THIS = this){
					window.$.get(window.baseurl + 'field/list', {}, function (D) {
						THIS.$localStorage.set('field', D);
					}, "json");
					if(!THIS.chechRole()){
						window.$.get(window.baseurl + 'accountTeacher/' + this.$route.params.id, {}, function (D) {
							THIS.val.page = 2;
							THIS.value = D.data.username;
							THIS.val.value = D.data.username;
							THIS.t_name = D.data.username.fullname +' ('+ THIS.t_status[D.data.username.status]+')';
						}, "json");
					}
				},
				// *********************************************************************
				next_page(e){
					this.val = e;
				},
				// *********************************************************************
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
						return true;
					}else if(user.username.role != 3){
						return true;
					}else{
						return false;
					}
				}
				// *********************************************************************
			}
		}
	</script>
<style>

</style>
